const brands = [
  "Ferco",
  "GU",
  "Roto",
  "Maco",
  "Siegenia",
  "Winkhaus",
  "Aubi",
  "Cadiou",
];

export default function AllBrands() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Toutes les marques
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-6 leading-tight">
            Réglage <span className="font-serif italic">toutes marques</span> de fenêtre
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-6">
            Peu importe la marque de votre fenêtre ou de son mécanisme : nos techniciens connaissent les spécificités de chaque fabricant. Les systèmes de réglage varient selon les marques — un gond Ferco ne se règle pas comme un gond GU. Nous avons l'expérience de toutes les grandes marques présentes sur le marché français, et nous intervenons sur des fenêtres de toutes générations.
          </p>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-8">
            Si votre fenêtre est ancienne et que la marque du mécanisme n'est plus visible, pas de panique. Nos techniciens identifient le système à vue d'œil et possèdent les adaptateurs nécessaires pour règler ou remplacer la pièce. Nous avons des stocks courants de pièces détachées pour les marques les plus répandues en Alsace.
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {brands.map((brand) => (
              <div
                key={brand}
                className="bg-rose-50 rounded-xl border border-rose-200 px-4 py-3 text-center"
              >
                <span className="text-plum-dark font-semibold text-sm">{brand}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}